import { AccountsContext } from '@paperstac/common/lib/components/AccountsProvider';
import useBreakpoints from '@paperstac/ui/lib/hooks/useBreakpoints';
import { HOME } from '@paperstac/routes/lib/webRoutes';
import Box from '@paperstac/ui/lib/Box';
import Button from '@paperstac/ui/lib/Button';
import Container from '@paperstac/ui/lib/Container';
import Flex from '@paperstac/ui/lib/Flex';
import Link from '@paperstac/ui/lib/Link';
import React from 'react';
import useMedia from 'use-media';
import { ReactComponent as Branding } from '../../../images/paperstac.svg';
import { IdentityManagerContext } from '../IdentityManager';
import AccountDropdown from './AccountDropdown';
import Nav from './Nav';

const Header = React.memo((props) => {
  const { isMobile } = useBreakpoints();
  const { currentAccount } = React.useContext(AccountsContext);
  const { showRegister } = React.useContext(IdentityManagerContext);
  const isTall = useMedia({ minHeight: 800 });

  // const isLoggedIn = !!currentAccount;
  const isBeforeBannerExpiry = new Date().getTime() < new Date('2026-03-10').getTime();
  const showGlobalBanner = isBeforeBannerExpiry;

  return (
    <>
      {!!showGlobalBanner && (
        <Box bg="gray.1" fontSize={2} py={1}>
          <Container>
            <div style={{ display: 'flex', gap: '16px', alignItems: 'center', justifyContent: 'center' }}>
              <p>
                We are experiencing a partial service outage that may affect some features. Our team is actively working
                to restore full service. If you need immediate help, contact{' '}
                <Link href="mailto:support@paperstac.com">support@paperstac.com</Link> or call{' '}
                <Link href="tel:407-930-9749">407-930-9749</Link>.
              </p>
            </div>
          </Container>
        </Box>
      )}
      <Box
        bg="white"
        sx={{
          width: '100vw',
          pt: [3, 3, 5],
          pb: [50, 53, 5],
          position: isTall ? 'sticky' : 'relative',
          top: 0,
          zIndex: 3,
        }}
      >
        <Container as={Flex} alignItems="center">
          <Box flex={1}>
            <Link to={HOME}>
              <Branding height={isMobile ? 24 : 30} style={{ verticalAlign: 'middle' }} />
            </Link>
          </Box>
          <Flex alignItems="center" display={['block']}>
            <Nav />
            {!currentAccount && (
              <Button onClick={showRegister} variant="primary" size="small">
                Register
              </Button>
            )}
            {!!currentAccount && <AccountDropdown />}
          </Flex>
        </Container>
      </Box>
    </>
  );
});

Header.propTypes = {};

Header.defaultProps = {};

Header.displayName = 'Header';

export default Header;
